<template>
  <div
    v-if="file.need_feedback"
    class="card"
  >
    <div class="card-body">
      <h4 class="">
        Need feedback
      </h4>
      <hr>

      <div
        v-if="file.response"
        class="mb-1"
      >
        <table class="table table-condensed table-striped table-bordered">
          <tr class="border">
            <td class="border">
              {{ file.response.name }}<br><small>{{ uploadedLine }}</small>
            </td>
            <td class="text-end border">
              <div class="row">
                <div class="col-6">
                  <a
                    v-if="canUpload"
                    style="color: red;"
                    title="Delete file"
                    @click="deleteResponse(file.response.id)"
                  ><i data-feather="trash-2" /></a>
                </div>
                <div class="col-6">
                  <a
                    :href="file.response_url"
                    target="_blank"
                    title="View file"
                  ><i data-feather="eye" /></a>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <!-- Same wording as the Tasks table and /intranet/cae/alerts (TaskResource::STATUS_LABELS).
           Whose response it is belongs in the row above, not in the status badge. -->
      <span
        v-if="file.response && file.response.accepted === true"
        class="badge bg-light-success"
      >Accepted</span>

      <span
        v-else-if="file.response && file.response.accepted === false"
        class="badge bg-light-danger"
      >Rejected</span>

      <span
        v-else-if="file.response && file.response.accepted === null"
        class="badge bg-light-warning"
      >Pending review</span>

      <!-- Several researchers answered this document: the backend can only return one
           of them when the URL carries no ?user, so say so instead of letting this
           badge read as the status of the whole document. -->
      <p
        v-if="file.response && !file.response_scoped_to_user && file.responses_count > 1"
        class="text-muted mt-50 mb-0"
      >
        <small>
          Showing 1 of {{ file.responses_count }} responses.
          <router-link :to="{ name: 'admin.cae.view-alerts', query: { actAs: $route.query.actAs } }">See all responses</router-link>
        </small>
      </p>

      <hr v-if="file.response">

      <template v-if="canUpload">
        <p class="text-muted mb-1">
          <small>
            1. Download the document · 2. Sign it in an external program (e.g. Signaturit) · 3. Upload the signed file for ICREA to validate.
          </small>
        </p>
        <div class="mb-1">
          <label
            for=""
            class="form-label"
          ><strong>Upload signed file</strong></label>
          <div
            class="input-group custom-file-button"
          >
            <label
              class="input-group-text"
              for="formFile"
            >Select file</label>
            <input
              id="formFile"
              :ref="`file-present-report`"
              class="form-control"
              type="file"
            >
          </div>
        </div>
        <a
          class="btn btn-small btn-primary"
          @click="upload"
        >Upload</a>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapGetters({
      fields: 'modals/tableSettingsFields',
      file: 'cae/file',
      filters: 'filters/filters',
    }),
    // filters.host is { id: undefined } when the view is deep-linked without ?host=, which would
    // drop host_id from the payload and leave the backend guessing the institution from the
    // logged-in user. Fall back to the route query, and never send a non-numeric id.
    hostId() {
      const id = (this.filters.host ? this.filters.host.id : null) ?? this.$route.query.host
      return id !== null && id !== undefined && id !== '' && !Number.isNaN(Number(id)) ? Number(id) : null
    },
    // The response can be (re)uploaded only while it is still open: no response yet,
    // pending review (accepted === null) or rejected (accepted === false). Once the
    // admin accepts it the document is locked — allowing another upload would silently
    // reset it back to pending on the backend.
    canUpload() {
      return this.file.need_feedback_check && (!this.file.response || this.file.response.accepted !== true)
    },
    // The document can hold one response per researcher, so the row says whose file it
    // is. The date comes formatted from the API: the raw response model serializes
    // created_at as UTC ISO-8601, which is unreadable.
    uploadedLine() {
      const uploaded = this.file.response_uploaded_at
      return this.file.response_user_name
        ? `Uploaded by ${this.file.response_user_name} · ${uploaded}`
        : `Uploaded: ${uploaded}`
    },
  },
  mounted() {

  },
  methods: {
    async deleteResponse(id) {
      Vue.swal({
        title: 'Do you want to delete the feedback response?',
        html: '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Yes',
      }).then(async result => {
        if (result.isConfirmed) {
          await this.$store.dispatch('cae/deleteResponse', { filters: this.filters, id, file: this.file.id })
        }
      })
    },
    async upload() {
      const file = this.$refs['file-present-report'].files[0]

      if (!file) {
        this.$toastr.error('', 'Please, upload a file first')
      } else {
        await this.$store.dispatch('cae/uploadResponse', {
          filters: this.filters, response: file, file: this.file.id, host_id: this.hostId,
        })
      }

      setTimeout(() => {
        feather.replace({
          width: 14,
          height: 14,
        })
      }, 100)
    },
  },
}
</script>
